import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridOptions } from "ag-grid/main";
import { ServerConstantsService, DataService, DateUtility, CommonUtility,
         REPSTDT_GT_REPENDDT, REPSTDT_INTERVAL_REPENDDT_3M} from '../shared';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import * as jsPDF from 'jspdf';
import * as canvg from 'canvg';


@Component({
    selector: 'app-component-activity-report',
    templateUrl: './component-activity-report.component.html',
    styleUrls: ['./component-activity-report.component.scss']
  })
  export class ComponentActivityReportComponent implements OnInit {
    chartData: any;

    ServerConstants: any;

    reportNames: any[];
    reportCounties: any[];
    reportProviders: any[];
    userActionNotificationsMap: any;
    report: any;
    reportCounty: any;
    reportProvider: any;

    reportBeginDate: any;
    reportEndDate: any;

    errorBeginDateField: any;
    errorEndDateField: any;
    errorMoreThanThreeMonthsDates: any;
    errorMandatoryProvider: any;
    errorMandatoryCounty: any;

    sharedData: any;

    componentActivitiesRequest: ComponentActivitiesVO;
    roleId: number;
    butDisabled: boolean = false;
    countyDisabled: boolean = false;
    providerDisabled: boolean = false;
    countyArray: string[] = [];
    countyId: any;
    provider: any;
    
    pdfDocument: boolean = false;
    loaderFocus: Boolean = false;
    loaderGenerateFocus: Boolean = false;
    componentActivityInput: boolean = false;

    reportSelectedCountyName : string;
    reportSelectedProviderName : string;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient,
        private dateUtil: DateUtility,
        private data: ReferenceTableService,
        private commonUtil: CommonUtility,
        private refTableService: ReferenceTableService,
        private notificationService: NotificationsService,
        public dataService: DataService,
        private serverConstantsService: ServerConstantsService
) {
    this.ServerConstants = serverConstantsService.getConstants();
}
    ngOnInit() {

        this.sharedData = this.dataService.getSharedDataObject();
        this.getReportNames();
        this.loadUserInformation();
        this.getUserActionNotifications();
              
        //Sets current report by default on dropdown.
        this.report = 'CA';

        if (this.sharedData.get("roles")[0].id == 5) {
          this.butDisabled = true;
        }
        else if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
        {
          this.butDisabled = true;
          this.countyDisabled =  true;
        }

    }

    getReportNames() {
        let reports = this.refTableService.getValueFromSharedDataMap("REPORT_NAME");
        this.reportNames = [];
        for (let entry of reports) {
            this.reportNames.push(entry);
        }
    }

    loadUserInformation() {
      
      this.http.post<any>(this.ServerConstants.REPORT_SERVER_API_URL+'/reportTaskSummary/loaduserdata', null).subscribe(
        data => {
            var role = '';
            if(data.hasOwnProperty('role')) {
                role = data['role'];
            }

        
            if (data.hasOwnProperty('counties')) {    
              let userCounties = data['counties'];
              var keys = Object.keys(userCounties);

              if((role !== 'County Supervisor') && (role !== 'County Worker')) {
                let userCounties = data['counties'];
                var keys = Object.keys(userCounties);
                this.reportCounties = [];
                var pickup = new DropdownValues();
                pickup.value = undefined;
                pickup.name = "Pick an option";
                this.reportCounties.push(pickup);                
                var pickup = new DropdownValues();
                pickup.value = "All"
                pickup.name = "All";
                this.reportCounties.push(pickup);
                for (let k of keys) {
                    var dv = new DropdownValues();
                    dv.value = k;
                    dv.name = userCounties[k];
                    this.reportCounties.push(dv);
                }           
               } else {
        
                  this.reportCounties = [];
                  for (let k of keys) {
                        var dv = new DropdownValues();
                        dv.value = k;
                        dv.name = userCounties[k];
                        this.reportCounties.push(dv);
                  }     
                  this.reportCounty  = this.reportCounties[0].value;            
                }
              }
    
            if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
            {  
                if (data.hasOwnProperty('providers')) {
                    let userProviders = data['providers'];
                    var keys = Object.keys(userProviders);
                    this.reportProviders = [];
                    
                    var pickup = new DropdownValues();
                    pickup.value = undefined;
                    pickup.name = "Pick an option";
                    this.reportProviders.push(pickup);                     
                    
                    /*var pickupAll = new DropdownValues();
                    pickupAll.value = "All"
                    pickupAll.name = "All";
                    this.reportProviders.push(pickupAll);*/
                    for (let k of keys) {
                        var dv = new DropdownValues();
                        dv.value = k;
                        dv.name = userProviders[k];
                        this.reportProviders.push(dv);
                    }    
                }
            } else if(this.sharedData.get("roles")[0].id == 5) {
              if (data.hasOwnProperty('providers')) {
                  let userProviders = data['providers'];
                  var keys = Object.keys(userProviders);
                  this.reportProviders = [];
                  for (let k of keys) {
                      var dv = new DropdownValues();
                      dv.value = k;
                      dv.name = userProviders[k];
                      this.reportProviders.push(dv);
                  }           
                  this.reportProvider  =  this.reportProviders[0].value;
               }
               this.providerDisabled = true; 
            } else {
              if (data.hasOwnProperty('providers')) {
                let userProviders = data['providers'];
                var keys = Object.keys(userProviders);
                this.reportProviders = [];
                
                var pickup = new DropdownValues();
                pickup.value = undefined;
                pickup.name = "Pick an option";
                this.reportProviders.push(pickup);                     
                
               var pickupAll = new DropdownValues();
                pickupAll.value = "All"
                pickupAll.name = "All";
                this.reportProviders.push(pickupAll);
                for (let k of keys) {
                    var dv = new DropdownValues();
                    dv.value = k;
                    dv.name = userProviders[k];
                    this.reportProviders.push(dv);
                }    
            }
          }

          }, response => {
            console.log('Get call in error', response);
          }, () => {
    
          });
    }

    getReportCounties() {
        this.reportCounties = this.refTableService.getValueFromSharedDataMap("COUNTIES");
    }

    getReportProviders() {
        //this.reportProviders  = this.refTableService.getValueFromSharedDataMap("COUNTIES");
    }

    getUserActionNotifications(){
        this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
    }

    onChange(value) {
        if (value == '1: CC') {
            this.router.navigate(["/reports/federalReports/CC"]);
        }

        if (value == '2: CR') {
            this.router.navigate(["/reports/federalReports/CR"]);
        }

        if (value == '3: ER') {
            this.router.navigate(["/reports/federalReports/ER"]);
        }

        if(value == '4: ET') {
           this.router.navigate(["/reports/employment-training-retention"]);
        }

        if(value == '5: SD') {
            this.router.navigate(["reports/monthly-snapshot-details"]);
        }
        if(value == '6: SR') {
            this.router.navigate(["reports/monthly-snapshot-rollup"]);
        }
        if(value == '7: CA') {
            this.router.navigate(["reports/component-activity"]);
        }
        if(value == '8: PC') {
          this.router.navigate(["reports/potential-candidates"]);
        }
        if(value == '9: AR') {
          this.router.navigate(["reports/aries-task"]);
        }
    }

    validDates() {
       if ((this.checkBeginDate() && this.checkEndDate())) {
          const startDt = new Date(this.reportBeginDate.year,
            this.reportBeginDate.month - 1,
            this.reportBeginDate.day);
           const endDt = new Date(this.reportEndDate.year,
            this.reportEndDate.month - 1,
            this.reportEndDate.day)
         
          
          if (startDt > endDt) {
            this.errorEndDateField = REPSTDT_GT_REPENDDT;
            return false;
          } else {
            this.errorEndDateField = null;
          }

          var nextTrimester = new Date(startDt);
          nextTrimester.setMonth(nextTrimester.getMonth() + 3)
          if(endDt >= nextTrimester)
          {
            this.errorMoreThanThreeMonthsDates = REPSTDT_INTERVAL_REPENDDT_3M;
            return false;
          } else {
            this.errorMoreThanThreeMonthsDates = null;
          }
        } 
    
        return true;
      }
  

      checkBeginDate() {
        if (this.reportBeginDate == undefined
          || this.reportBeginDate == null) {
          this.errorBeginDateField = "Missing Begin Date";
          return false;
        }
  
        this.errorBeginDateField = null;
        return true;
      }
    
      checkEndDate() {
        if (this.reportEndDate == undefined
          || this.reportEndDate == null) {
          this.errorEndDateField = "Missing End Date";
          return false;
        }
        this.errorEndDateField = null;
        return true;
      }
    
      checkMandatoryParameters() {
        return (this.checkMandatoryCounty() && this.checkMandatoryProvider());
      }
  
      checkMandatoryProvider() {
          if(( this.reportProvider !== undefined
              && this.reportProvider !== null)) {
                this.errorMandatoryProvider = null;
                return true;
          } 
          this.errorMandatoryProvider = "Please select a Provider";
          return false;
          
      }
  
      checkMandatoryCounty() {
          if (this.reportCounty !== undefined
                  && this.reportCounty !== null) {
                    console.log(this.reportCounty);
                    this.errorMandatoryCounty = null;
                    return true; 
          } 
          this.errorMandatoryCounty = "Please select a County";
          return false; 
      }
  
      
      searchComponents(event) {
        if((this.checkMandatoryParameters() && this.validDates()))
        {
          console.log('searchComponents');
          this.componentActivitiesRequest = new ComponentActivitiesVO();
    
          if (this.reportBeginDate != null) {
            let day = this.reportBeginDate.day;
            let month = this.reportBeginDate.month;
            let year = this.reportBeginDate.year;
            if (day < 10 && month < 10) {
              this.reportBeginDate = year + '/0' + month + '/0' + day;
            }
            else if (day < 10) {
              this.reportBeginDate = year + '/' + month + '/0' + day;
            }
            else if (month < 10) {
              this.reportBeginDate = year + '/0' + month + '/' + day;
            }
            else {
              this.reportBeginDate = year + '/' + month + '/' + day;
            }
          }
    
          if (this.reportEndDate != null) {
                let day = this.reportEndDate.day;
                let month = this.reportEndDate.month;
                let year = this.reportEndDate.year;
                this.reportEndDate = year + '/' + month + '/' + day;
                if (day < 10 && month < 10) {
                this.reportEndDate = year + '/0' + month + '/0' + day;
                }
                else if (day < 10) {
                this.reportEndDate = year + '/' + month + '/0' + day;
                }
                else if (month < 10) {
                this.reportEndDate = year + '/0' + month + '/' + day;
                }
                else {
                this.reportEndDate = year + '/' + month + '/' + day;
                }
            }
    
            this.componentActivitiesRequest.providerCode = this.reportProvider;

            if(this.reportCounty !== undefined && this.reportCounty !== null) {
              this.componentActivitiesRequest.countyCode= this.reportCounty;
            }
            if(this.reportProvider !== undefined && this.reportProvider !== null){
              this.componentActivitiesRequest.providerCode=this.reportProvider;
            }

            this.componentActivitiesRequest.reportBeginDate=this.reportBeginDate;
            this.componentActivitiesRequest.reportEndDate=this.reportEndDate;
        
            event.srcElement.blur();
            event.preventDefault(); 
      
          this.loadComponentActivities();
          this.chartData = null;
        }

    }

    loadComponentActivities () {
        this.http.post<ComponentActivitiesVO>(this.ServerConstants.REPORT_SERVER_API_URL
            +'/reportTaskSummary/componentactivity', this.componentActivitiesRequest).subscribe(
          (data:ComponentActivitiesVO ) => {
            // convert date to the proper format for UI
            
            this.componentActivitiesRequest = data;
            this.componentActivityInput = true;
            this.pdfDocument = true;

            this.chartData = this.format(this.componentActivitiesRequest.periods);

            if (data.reportBeginDate!= null) {
              this.reportBeginDate = this.dateUtil.convertDateFromServerForreports(data.reportBeginDate);
            }
  
            if (data.reportEndDate!= null) {
              this.reportEndDate = this.dateUtil.convertDateFromServerForreports(data.reportEndDate);
            }

            if (data.countyCode!= null) {
              this.reportCounty = data.countyCode;
            }

            if (data.providerCode!= null) {
              this.reportProvider = data.providerCode;
            }
          }, response => {
            //this.notificationService.error('Report Summary', this.userActionNotificationsMap.ERROR);
          }, () => {
    
    
          });
        }

        format(periods: ComponentActivitiesPeriodVO[]) {
          var results:string = '[';
          for (let entry of periods) {
            var period:string = '{"Month":"' + entry.month + '",';
            Object.keys(entry.componentsUsersCount).map( key => {
              period = period + '"' + key + '":' + entry.componentsUsersCount[key] + ",";
            });
            period = period.slice(0, -1);
            period = period + '}';
            results = results  + period + ',';
          }
          results = results.slice(0, -1); 
          results = results + ']';
          return results;
        }

        onChangeCounty(value) {
          var valueSelected = value.split(':')
          var id = valueSelected[0].trim();
          if(id !== 'All' && id !== undefined) {
           this.reportSelectedCountyName = this.reportCounties[id].name;
          } else if(id == 'All' && id !== undefined) {
              this.reportSelectedCountyName ='All';
          } else {
            this.reportSelectedCountyName = undefined;
          }
          this.errorMandatoryCounty = false;
      }
  
      onChangeProvider(value) {
        var valueSelected = value.split(':')
        var id = valueSelected[0];
        this.reportSelectedProviderName = this.reportProviders[id].name;
        this.errorMandatoryProvider = false;
      }

        downloadnodePDF(event){
          var width = 420;
          var height = 220;
          var temp = [420, 220];
          var doc = new jsPDF("p", "mm", "a1");
          var rows = [];
    
          let canvas = document.createElement('canvas');
          let svg = document.getElementsByTagName('svg')[0];
          let svgWidth = svg.getAttribute('width');
          let svgHeight = svg.getAttribute('height');
          canvas.setAttribute ('width', svgWidth);
          canvas.setAttribute ('height', svgHeight);
          svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
          svg.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink')
          canvg(canvas, svg.innerHTML);
          let imgData = canvas.toDataURL('image/png');
         
    
          if(this.reportSelectedCountyName !== undefined && this.reportSelectedCountyName !== null) {
              doc.text(15, 10, 'Report : Component Activity Report  - ' );
              doc.text(15, 25, 'County :'  + this.reportSelectedCountyName
              + ' - Provider: ' + this.reportSelectedProviderName );
          }
          doc.addImage(imgData, 'PNG', 15, 30, 150, 150);
    
          doc.save('Component_Activity_Report.pdf');
        
      }
    }
    


export class dropdownValues {
    constructor(  
        public name?:string,
         public value?:string,
    ) {}
  }
export class ComponentActivitiesVO {
    constructor(
        public reportBeginDate?: any,
        public reportEndDate?: any,
        public countyCode?:string,
        public providerCode?:string,
        public periods?: ComponentActivitiesPeriodVO[],
    ) {}
}

export interface ComponentActivitiesPeriodVO {
   month: string;
   componentsUsersCount: Map<string, string>;
  
}

export class DropdownValues {
  constructor(  
      public name?:string,
       public value?:string,
  ) {}
}


// WEBPACK FOOTER //
// ./src/app/component-activity-report/component-activity-report.component.ts